import { renderContactInfo } from "../../../../utils";
import ContactForm2 from "../../contact/form2";
import SEO from "../../seo";

function ContactUs1Page({ siteName,pageTitle, layoutInfo }) {
    console.log('contact us 1 layout info map url', layoutInfo)
    return (
        <>
            <SEO 
                siteName={siteName}
                pageTitle={pageTitle}
                description=""
                keywords=""
            />
 
            <div className="section-full p-t80">
                <div className="container">
                    
                    <div className="section-content">
               
                        <div className="mt-box">
                            <div className="gmap-outline">
                                <div className="google-map" style={{ width: '100%' }}>
                                   
                                    <iframe height={460} src={layoutInfo?.map_url}  />
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="section-full p-t80">
                <div className="container">
                    <div className="section-head">
                        <h2>Contact Detail </h2>
                        <div className="mt-separator-outer m-b30">
                            <div className="mt-separator site-bg-primary" />
                        </div>
                    </div>
                    <div className="section-content m-b30">
                        <div className="row">
                            <div className="col-md-4 col-sm-12 m-b30">
                                <div className="mt-icon-box-wraper center p-a30 bg-gray">
                                    <div className="icon-sm m-b10"><i className="iconmoon-smartphone-1" /></div>
                                    <div className="icon-content">
                                        <h4 className="site-text-primary">Phone</h4>
                                        { renderContactInfo(layoutInfo?.contact_number )}
                                        {/* <p>{layoutInfo?.contact_number}</p> */}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-12 m-b30">
                                <div className="mt-icon-box-wraper center p-a30 bg-gray">
                                    <div className="icon-sm m-b10"><i className="iconmoon-email" /></div>
                                    <div className="icon-content">
                                        <h4 className="site-text-primary">Email</h4>
                                        { renderContactInfo(layoutInfo?.email )}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-12 m-b30">
                                <div className="mt-icon-box-wraper center p-a30 bg-gray">
                                    <div className="icon-sm m-b10"><i className="iconmoon-travel" /></div>
                                    <div className="icon-content">
                                        <h4 className="site-text-primary">Address</h4>
                                        <p>{layoutInfo?.company_address}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="section-full">
                <ContactForm2
                    options={{
                        map_url: layoutInfo?.map_url
                    }}
                />
                
            </div>
        </>
    )
}
export default ContactUs1Page;